

import { Vue, Component } from 'vue-property-decorator';
import { servicerAddList, agree } from '@/api/service';
import { UserModule } from '@/store/modules/user';

@Component({ name: '' })
export default class extends Vue {
  // ----------------搜索/列表----------------
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private formSearch: any = {
    servicer_company_name: ''
  }
  // 列表内容定义
  private listLoading = false
  private serviceList: any[] = [];

  serachHandle() {
    this.getServiceList();
  }
  serachCleanHandle() {
    this.formSearch.servicer_company_name = '';
    this.pagination.currentPage = 1;
    this.getServiceList();
  }

  private getServiceList() {
    var params = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      servicer_company_name: this.formSearch.servicer_company_name,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };

    this.listLoading = true;
    servicerAddList(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.pagination.total = parseInt(data.count);
        this.serviceList = data.list;
        for (var i = 0; i < this.serviceList.length; i++) {
          var temp = this.serviceList[i];
          temp.servicer_type_str = (temp.servicer_type === '1') ? '公司' : '个人';
          this.$set(this.serviceList, temp, i);
        }
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getServiceList()
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getServiceList()
  }

  // ----------------搜索/列表----------------
  // ----------------同意----------------
  agreeHandle(val : any) {
    this.$confirm('确定同意将' + val.servicer_company_name + '添加为服务方', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.agree(val);
    }).catch(() => {
    });
  }
  agree(val : any) {
    var params = {};
    if (val.servicer_type === '1') {
      params = {
        company_id: UserModule.getCompanyId,
        user_id: UserModule.getUserId,
        id: val.id,
        servicer_type: val.servicer_type,
        servicer_company_id: val.servicer_company_id,
        servicer_company_name: val.servicer_company_name
      };
    } else {
      params = {
        company_id: UserModule.getCompanyId,
        user_id: UserModule.getUserId,
        id: val.id,
        servicer_type: val.servicer_type,
        servicer_user_id: val.servicer_user_id,
        servicer_user_name: val.servicer_user_name
      };
    }
    agree(params).then(res => {
      this.showSecussMsg('操作成功');
      this.getServiceList();
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // ----------------同意----------------

  created() {
    this.getServiceList();
  }

  showErrorMsg(msg:string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  showSecussMsg(msg:string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
